import React from "react";
import { Robot } from "../robot";
import { Box } from "@material-ui/core";
import { useRequestContext } from "../../context";

export const Message: React.FC = () => {
  const [requestContextState] = useRequestContext();

  return (
    <Box display="flex" alignItems="center" height="100%">
      <Robot
        message={requestContextState.message?.content}
        error={requestContextState.message?.error}
      />
    </Box>
  );
};
